Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PctyListColumn = require('./PctyListColumn');

var _PctyListColumn2 = _interopRequireDefault(_PctyListColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PctyListCheckboxColumn = function PctyListCheckboxColumn(_ref) {
  var onChange = _ref.onChange,
      checked = _ref.checked,
      automationId = _ref.automationId,
      other = _objectWithoutProperties(_ref, ['onChange', 'checked', 'automationId']);

  var otherProps = other;
  otherProps.className = ((other.className || '') + ' pcty-list-checkbox').trim();
  var checkboxProps = { 'data-automation-id': automationId || null };

  return _react2.default.createElement(
    _PctyListColumn2.default,
    otherProps,
    _react2.default.createElement('input', _extends({ type: 'checkbox', checked: checked, onChange: onChange }, checkboxProps))
  );
};

PctyListCheckboxColumn.propTypes = {
  /** A handler for the checkbox change event */
  onChange: _propTypes2.default.func,
  /** Indicates if the checkbox is checked or not */
  checked: _propTypes2.default.bool,
  /** A string that can be referenced by UI automation tools */
  automationId: _propTypes2.default.string
  /** INCLUDE OTHER */
};

PctyListCheckboxColumn.defaultProps = {
  onChange: function onChange() {},
  checked: false
};

exports.default = PctyListCheckboxColumn;